import { render } from "./attractionsResultsItem.vue?vue&type=template&id=f97b44aa"
import script from "./attractionsResultsItem.vue?vue&type=script&lang=js"
export * from "./attractionsResultsItem.vue?vue&type=script&lang=js"
script.render = render

export default script